// extracted by css-extract-rspack-plugin
export default {"employeeListModal":"employeeListModal-aTywow","employeeListModalHeader":"employeeListModalHeader-CvI0jX","employeeList":"employeeList-LGKCyp","employeeCard":"employeeCard-WMUC8X"};